var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-2 d-flex flex-column"},[_c('div',{staticClass:"body-1"},[_vm._v(_vm._s(_vm.title))]),_c('v-select',{attrs:{"disabled":_vm.disabled,"items":_vm.options,"value":_vm.value,"chips":"","clearable":"","dense":"","multiple":""},on:{"change":value => _vm.$emit('change', value)}}),_c('v-divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }